(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/lobby/lobby.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/lobby/lobby.js');
"use strict";


const {
  createContext,
  useReducer
} = React;
const LobbyContext = createContext();
setGlobal('svs.eInstant.lobby.LobbyContext', LobbyContext);
const LobbyProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    reducer,
    initialState
  } = svs.eInstant.lobby;
  const [state, dispatch] = useReducer(reducer, initialState);
  return React.createElement(LobbyContext.Provider, {
    value: {
      gameConfigs: svs.eInstant.data.gameConfigs,
      lobbyHeader: svs.eInstant.data.lobbyHeader,
      dispatch,
      state
    }
  }, children);
};
setGlobal('svs.eInstant.lobby.LobbyProvider', LobbyProvider);
const Info = () => {
  const {
    useContext
  } = React;
  const {
    InfoOverlay
  } = svs.eInstant.lobby;
  const {
    state
  } = useContext(svs.eInstant.lobby.LobbyContext);
  return state.gameUrl && React.createElement(InfoOverlay, {
    key: state.gameUrl
  });
};
const Lobby = () => {
  const Games = svs.eInstant.lobby.Games;
  const WidgetArea = svs.eInstant.lobby.WidgetArea;
  return React.createElement(LobbyProvider, null, React.createElement("div", {
    className: "js-e-instant"
  }, React.createElement(WidgetArea, {
    areaName: "hero",
    className: "full-width-widget"
  }), React.createElement(WidgetArea, {
    areaName: "lobby",
    className: "u-text-left widget-default-margin-top-0 widget-area-e-instant-lobby"
  }), React.createElement("div", {
    className: "dots dots-e-instant"
  }, React.createElement("div", {
    className: "e-instant-lobby-bg"
  }, React.createElement(Games, null)))), React.createElement(Info, null));
};
setGlobal('svs.eInstant.lobby.Lobby', Lobby);

 })(window);